import { cookieBannerStore } from 'src/stores';

export const hideCookieBanner = () => {
  localStorage.setItem('cookies-banner', 'false');
  cookieBannerStore.setValue(false);
};
